import './Button.css';

const Button = ({children, style, onClick}) => {
	return (
		<button className="normalButton" style={style} onClick={onClick}>
			{children}
		</button>
	);
}

export default Button;